module.exports = __webpack_public_path__ + "media/app/img/maps/cover-9793250c61118f4fe73e5745b3bd6add.png";